var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnsweredMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3879 18.2485C15.698 18.2485 19.1919 14.7546 19.1919 10.4446C19.1919 6.13458 15.698 2.64062 11.3879 2.64062C7.07794 2.64062 3.58398 6.13458 3.58398 10.4446C3.58398 14.7546 7.07794 18.2485 11.3879 18.2485Z",
    stroke: "#2C974B",
    strokeWidth: 1.73421,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 10.5,
    r: 7.5,
    fill: "#2C974B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53298 9.83188C8.19435 9.49327 7.64533 9.49327 7.3067 9.83188C6.96808 10.1705 6.96808 10.7195 7.3067 11.0581L8.53298 9.83188ZM10.5212 13.0463L9.90803 13.6595C10.0803 13.8318 10.317 13.9236 10.5604 13.9126C10.8038 13.9015 11.0314 13.7886 11.1873 13.6014L10.5212 13.0463ZM15.5228 8.39879C15.8294 8.03091 15.7797 7.48414 15.4118 7.17756C15.0439 6.87098 14.4971 6.92069 14.1906 7.28859L15.5228 8.39879ZM7.3067 11.0581L9.90803 13.6595L11.1343 12.4332L8.53298 9.83188L7.3067 11.0581ZM11.1873 13.6014L15.5228 8.39879L14.1906 7.28859L9.85505 12.4912L11.1873 13.6014Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnsweredMark);
export default __webpack_public_path__ + "static/media/answered_mark.d1145e6b8cefb6827ba3c1d3922342bf.svg";
export { ForwardRef as ReactComponent };